import React from 'react';
import styled from 'styled-components';
import NearMeOutlinedIcon from '@material-ui/icons/NearMeOutlined';

import { Button } from 'common/components/buttons/Button';
import { Loader } from 'common/components/Loader';

const CurrentLocationIcon = styled(NearMeOutlinedIcon)`
    width: 35px;
    height: 35px;
`;

interface IProps {
    active: boolean;
    className?: string;
    loading: boolean;
    onClick(): void;
}

const BaseCurrentLocationButton: React.FC<IProps> = ({
    className,
    loading,
    onClick,
}) => (
    <Button fullWidth className={className} onClick={onClick}>
        {loading ? <Loader /> : <CurrentLocationIcon />}
    </Button>
);

export const CurrentLocationButton = styled(BaseCurrentLocationButton)`
    width: 65px;
    height: 65px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background-color: ${({ active, theme }) =>
        active ? theme.palette.primary.main : theme.palette.grey[50]};
    border-radius: 5px;

    :hover {
        background-color: ${({ theme }) => theme.palette.primary.main};

        ${CurrentLocationIcon} {
            fill: ${({ theme }) => theme.palette.background.paper};
        }
    }

    ${CurrentLocationIcon} {
        width: 25px;
        height: 25px;
        fill: ${({ active, theme }) =>
            active
                ? theme.palette.background.paper
                : theme.palette.text.primary};
    }
`;
